"use client";
import React from "react";
import { motion } from "framer-motion";
import { MdOutlineEmail } from "react-icons/md";
import { LuPhone, LuCalendarDays } from "react-icons/lu";
import { GiModernCity } from "react-icons/gi";
import { MdOutlineAttachMoney, MdFamilyRestroom } from "react-icons/md";
import { IoColorPaletteOutline } from "react-icons/io5";
import {useTranslation} from "react-i18next";
export default function ClientInfoCard({ client }) {
  const {t} = useTranslation();

  const familyOptions = [
    { value: "Single", label: t("home.familySingle") },
    { value: "Married", label: t("home.familyMarried") },
    { value: "In a relationship", label: t("home.familyInRelationship") },
    { value: "Engaged", label: t("home.familyEngaged") },
    { value: "Separated", label: t("home.familySeparated") },
    { value: "Divorced", label: t("home.familyDivorced") },
  ];

  const hobbyOptions = [
    { value: "Reading", label: t("home.hobbyReading") },
    { value: "Series", label: t("home.hobbySeries") },
    { value: "Anime", label: t("home.hobbyAnime") },
    { value: "Festivals", label: t("home.hobbyFestivals") },
    { value: "Martial arts", label: t("home.hobbyMartialArts") },
    { value: "Cooking", label: t("home.hobbyCooking") },
    { value: "Mountains", label: t("home.hobbyMountains") },
    { value: "Healthy lifestyle", label: t("home.hobbyHealthyLifestyle") },
    { value: "Motos", label: t("home.hobbyMotos") },
    { value: "Fishing/Hunting", label: t("home.hobbyFishingHunting") },
    { value: "Gardening", label: t("home.hobbyGardening") },
    { value: "Traveling", label: t("home.hobbyTraveling") },
    { value: "Pets", label: t("home.hobbyPets") },
    { value: "Games", label: t("home.hobbyGames") },
    { value: "Museums", label: t("home.hobbyMuseums") },
    { value: "Photography", label: t("home.hobbyPhotography") },
    { value: "Business", label: t("home.hobbyBusiness") },
  ];

  const currentFamilyOption = familyOptions.find(o => o.value === client.family_status);
  const displayFamilyStatus = currentFamilyOption ? currentFamilyOption.label : (client.family_status || "-");

  const displayHobbies = client.hobbies
    ? String(client.hobbies)
        .split(",")
        .map(h => h.trim())
        .filter(Boolean)
        .map(h => {
          const found = hobbyOptions.find(o => o.value === h);
          return found ? found.label : h;
        })
        .join(", ")
    : "-";

  const infoItems = [
    [
      {
        icon: <MdOutlineEmail />,
        label: t("home.email"),
        value: client.email || "-",
        accent: "border-l-[#020637]"
      },
      {
        icon: <LuPhone />,
        label: t("phoneNumber"),
        value: client.phone_number || "-",
        accent: "border-l-[#020637]"
      },
      {
        icon: <MdOutlineAttachMoney />,
        label: t("home.labelTaxId"),
        value: client.tax_id || "-",
        accent: "border-l-[#020637]"
      },
      {
        icon: <LuCalendarDays />,
        label: t("home.labelCompanyName"),
        value: client.company_name || "-",
        accent: "border-l-[#020637]"
      },
    ],
    [
      {
        icon: <GiModernCity />,
        label: t("home.labelCountry"),
        value: client.country || "-",
        accent: "border-l-[#020637]"
      },
      {
        icon: <MdFamilyRestroom />,
        label: t("home.labelFamilyStatus"),
        value: displayFamilyStatus,
        accent: "border-l-[#020637]"
      },
      {
        icon: <IoColorPaletteOutline />,
        label: t("home.labelHobbies"),
        value: displayHobbies,
        accent: "border-l-[#020637]"
      },
      {
        icon: <LuCalendarDays />,
        label: t("home.labelBirthday"),
        value: client.birthday || "-",
        accent: "border-l-[#020637]"
      },
    ]
  ];

  return (
    <div className="grid md:grid-cols-2 gap-4 w-full">
      {infoItems.map((column, colIndex) => (
        <div key={colIndex} className="space-y-2">
          {column.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: -10 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.3, delay: index * 0.05 + colIndex * 0.1 }}
              whileHover={{ 
                backgroundColor: "rgba(249, 250, 251, 0.8)",
                paddingLeft: "14px"
              }}
              className={`bg-white rounded-lg p-3 border border-gray-100 ${item.accent} border-l-4 transition-all duration-200 hover:shadow-xs`}
            >
              <div className="flex items-center gap-3">
                <div className="text-gray-600">
                  {item.icon}
                </div>
                
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between">
                    <span className="text-xs font-medium text-gray-500">
                      {item.label}
                    </span>
                    <span className="text-sm text-gray-800 font-medium truncate ml-3 max-w-[160px]">
                      {item.value}
                    </span>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      ))}
    </div>
  );
}